import { useContext, useEffect } from 'react';
import AddBlack from '../../../Assets/PlusIcon/AddBlack.svg';
import { InventoryAddProductFormContext } from '../../../Context/InventoryAddProductFormContext';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/inventoryManagementSlice';
import { specificationsArray } from '../../../Routes/InventoryManagement/Specifications';
import { toCamelCase } from '../../../lib/utils/utils';
import { showToast } from '../../../Components/Toaster/Toaster';
import Input from '../../../Components/Input/Input';

function Specification({ selectedCategory1, selectedCategory2 }) {
    const dispatch = useDispatch();

    const {
        specifications,
        setSpecifications,
        productSpecifications,
        setProductSpecifications,
        additionalSpecifications,
        setAdditionalSpecifications,
        formErrors
    } = useContext(InventoryAddProductFormContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const character = e.nativeEvent.data;

        if(name === 'size' && character === ',') {
            showToast('Invalid input', 'warning');
        }
        else {
            setSpecifications({ ...specifications, [name]: value });
        }
    }

    const handleProductSpecificationsChange = (e) => {
        const { name, value } = e.target;
        setProductSpecifications(prevSpecs => 
            prevSpecs.map(spec => spec.id === name ? { ...spec, value } : spec)
        )
    }

    const handleAdditionalSpecificationsChange = (e) => {
        const { name, value } = e.target;
        setAdditionalSpecifications(prevSpecs => 
            prevSpecs.map(spec => spec.id === name ? { ...spec, value } : spec)
        )
    }

    const handleAddCustomField = () => {
        dispatch(setModal('add-custom-field'));
    }

    useEffect(() => {
        let specificationsList = specificationsArray.filter(specification => specification.id.includes(selectedCategory2));

        let result = specificationsList[0]?.list
        ?.map(option => (
            {
                labelText: option,
                id: toCamelCase(option),
                value: '',
            }
        ));

        selectedCategory2 && setProductSpecifications(result);
        // eslint-disable-next-line
    }, [selectedCategory2]);

    return (
        <div className="flex flex-col gap-3 border border-[#EAEAEA] p-5 rounded-xl">
            <h1 className='font-semibold text-[18px] leading-[26px]'>Specification</h1>

            <div className="font-medium text-base text-[#121212]">{selectedCategory2}</div>

            <div className="grid grid-cols-2 gap-x-2 gap-y-3">
                <Input 
                    labelText='Color' 
                    errorText={formErrors.color} 
                    inputOptions={{
                        type: 'text',
                        id: 'color',
                        name: 'color',
                        value: specifications.color,
                        onChange: handleChange
                    }}
                    required={selectedCategory1 !== 'Beauty & Personal Care'}
                />

                <Input 
                    labelText={selectedCategory1 === 'Beauty & Personal Care' ? 'Volume' : 'Size'} 
                    errorText={formErrors.size} 
                    inputOptions={{
                        type: 'text',
                        id: 'size',
                        name: 'size',
                        value: specifications.size,
                        onChange: handleChange
                    }}
                    required
                />

                {productSpecifications?.map(field => {
                    return (
                        <Input 
                            key={field.id} 
                            labelText={field.labelText} 
                            inputOptions={{
                                type: 'text',
                                id: field.id,
                                name: field.id,
                                value: field.value,
                                onChange: handleProductSpecificationsChange
                            }}
                        />
                    );
                })}

                {additionalSpecifications.map(field => {
                    return (
                        <Input 
                            key={field.id} 
                            labelText={field.labelText} 
                            inputOptions={{
                                type: 'text',
                                id: field.id,
                                name: field.id,
                                value: field.value,
                                onChange: handleAdditionalSpecificationsChange
                            }}
                        />
                    );
                })}
            </div>

            <button onClick={handleAddCustomField} className="py-[10px] flex gap-1 w-fit">
                <div className="w-6 h-6 flex items-center justify-center">
                    <img src={AddBlack} alt="" />
                </div>

                <p className='font-semibold text-base text-primaryColor'>Add custom field</p>
            </button>
        </div>
    );
}

export default Specification;
